import type { ContainerRow } from "@/lib/api";
import { Lock } from "lucide-react";
import { ROLE_LABEL, personName } from "./access-copy";

// Your role in the Boo, or who owns it when you have none.
export function BooAccessLine({ container }: { container: ContainerRow }) {
  const owners = container.owners ?? [];
  const ownerText = owners.length
    ? `Owned by ${personName(owners[0])}${owners.length > 1 ? ` and ${owners.length - 1} more` : ""}`
    : "No owner";
  if (container.myRole) {
    return (
      <div className="flex min-w-0 items-center gap-1.5 text-xs text-muted-foreground">
        <span className="shrink-0 rounded bg-muted px-1.5 py-0.5 font-medium text-foreground">{ROLE_LABEL[container.myRole]}</span>
        {container.myRole !== "owner" && <span className="truncate">{ownerText}</span>}
      </div>
    );
  }
  return (
    <div className="flex min-w-0 items-center gap-1.5 text-xs text-muted-foreground">
      <Lock className="size-3 shrink-0" />
      <span className="truncate">No access · {ownerText}</span>
    </div>
  );
}
